import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'groupBy',
    standalone: true
})
export class GroupByPipe implements PipeTransform {
    transform(input: any, prop: string): Array<any> {
        if (!Array.isArray(input)) {
            return input;
        }

        const arr: { [key: string]: Array<any> } = {};

        for (const value of input) {
            const field: any = this.getProperty(value, prop);

            if (arr[field] === undefined) {
                arr[field] = [];
            }

            arr[field].push(value);
        }

        const result = Object.keys(arr).map((key) => ({ key, value: arr[key] }));
        return result;
    }
    isObject(value: any): boolean {
        return value !== null && typeof value === 'object';
    }
    isNil(value: any): value is null | undefined {
        return value === null || typeof value === 'undefined';
    }
    getProperty(value: { [key: string]: any }, key: string): any {
        if (this.isNil(value) || !this.isObject(value)) {
            return undefined;
        }

        const keys: string[] = key.split('.');
        let result: any = value[keys.shift()!];

        for (const key of keys) {
            if (this.isNil(result) || !this.isObject(result)) {
                return undefined;
            }

            result = result[key];
        }

        return result;
    }
}
